export default __webpack_public_path__ + "static/media/help_3_shortkey.86aa9435.gif";